export { SchoolFormModal } from './school-form-modal';
